import { getApi } from './utils';

const host = process.env.VUE_APP_HOST_KOACH;

export async function getApiDataDynamic(token) {
  const API_URL = `${host}/dynamicData`;
  return getApi(API_URL, token);
}
